module.exports = __webpack_public_path__ + "assets/img/star_sentence4.ceb6cce2.png";